<template>
  <div :class="classNames">
     <!-- @click="deselectHandler" -->
    <slot name="toolbar" :class="classNames"></slot>
    <CollectionLoader v-if="isLoading" />
    <div class="mui-list mui-layout__collection">
      <ScrollLayout
        :onScroll="onScroll"
        ref="scrollLayout">
        <slot></slot>
      </ScrollLayout>
    </div>
  </div>
</template>

<script>
import ScrollLayout from '@/layouts/ScrollLayout'
// import { REMOVE_VIEW_DETAIL } from '@/modules/mutation-types'
const CollectionLoader = {
  template: '<div class="mui-layout__collection--loading"><div class="loader loader--processing loader--large"></div></div>'
}
export default {
  name: 'CollectionLayout',
  components: {
    CollectionLoader,
    ScrollLayout
  },
  computed: {
    classNames () {
      return {
        'layout__collection': true,
        'has-toolbar': !!this.$slots.toolbar,
        'is-scrolled': this.isScrolled
      }
    }
  },
  data () {
    return {
      isScrolled: false
    }
  },
  methods: {
    // deselectHandler (ev) {
    //   if (ev.target.classList.contains('layout__scroll')) this.onDeselect()
    // },
    onScroll (ev) {
      this.isScrolled = ev.target.scrollTop > 0
    },
    resetScroll () {
      this.$refs.scrollLayout.resetScroll()
    }
  },
  props: {
    isLoading: {
      default: false,
      type: Boolean
    }
    // onDeselect: {
    //   type: Function,
    //   default: () => {}
    // }
  }
}
</script>

<style lang="sass">
@import "../styles/variables.scss"
@import "../styles/loader.sass"

.layout__collection
  &.has-toolbar .layout__scroll
    height: calc(100vh - #{$toolbarHeight})
  .layout__scroll
    height: 100vh
  .mui-toolbar__titlebar
    padding: 0 12px 0 18px

.mui-layout__collection
  .device__platform--ios.device__browser--safari &
    padding-bottom: 144px
  .mui-list-item
    line-height: 24px
    min-height: 72px
    padding-top: 16px
    padding-right: 0
    padding-bottom: 16px
    & > span
      transition: opacity $sheetSpeed/2 $animationTimingFunction
    &:after
      position: absolute
      content: ""
      border-top: $layoutBorder
      width: calc(100% - 24px)
      top: 0
      left: 24px
    // &:first-child:not(.is-selected):after
    &:first-child:after
      border-top: none
    .device__viewport-class--compact &
      &:last-child
        margin-bottom: $toolbarHeight
    &.is-selected
      background: #f2f8ff
    &.is-selected:after
      border-color: rgba(0, 0, 0, 0.04)
      width: 100%
      left: 0
    &.is-selected + .mui-list-item:after
      border-color: rgba(0, 0, 0, 0.04)
      width: 100%
      left: 0
    &.is-processing
      & > span
        opacity: 0.3

    .mui-list-item__text
      .device__viewport-class--compact &
        font-size: 18px
        line-height: 26px
    .mui-list-item__secondary-text
      color: $subtleTextColor
      font-weight: 300
    .mui-list-item__meta
      margin-top: 5px
      margin-right: 24px
      .device__viewport-class--regular
        margin-right: 8px
      & > div
        background-position: center
        background-size: cover
        height: 60px
        width: 90px
        &[lazy=loading]
          background: #fafafa
        &[lazy=error]
          display: none
.mui-layout__collection--zero
  margin-top: 72px
  padding: 24px
  text-align: center
  h3
    font-weight: 500
.mui-layout__collection--loading
  height: 48px
  margin-top: 72px
  padding: 24px
  .loader.loader--processing::before
    left: calc(50% - 8px)
</style>



// WEBPACK FOOTER //
// src/layouts/CollectionLayout.vue